// extracted by mini-css-extract-plugin
export var standaloneTable = "_d9-0";
export var standaloneTableWithBodyFill = "_d9-1";
export var withExtraHeader = "_d9-2";